import React, { useState, useEffect } from "react";
import SocialService from "../../services/SocialService";
import { Link } from "react-router-dom";
import { motion } from "motion/react";
const ListSocial = () => {
  const [social, setSocial] = useState([]);
  const [currentSocial, setCurrentSocial] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchTitle, setSearchTitle] = useState("");

  useEffect(() => {
    retrieveSocial();
  }, []);

  const retrieveSocial = () => {
    SocialService.getAll()
      .then((response) => {
        setSocial(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const setActiveSocial = (social, index) => {
    setCurrentSocial(social);
    setCurrentIndex(index);
  };

  const refreshList = () => {
    retrieveSocial();
    setCurrentSocial(null);
    setCurrentIndex(-1);
  };

  // console.log("Current Social:"+JSON.stringify(currentSocial))

  return (
    <>
      <div className="pb-10  bg-slate-100 w-full">
        <div className="flex flex-row-2 w-full h-16 text-center relative gap-y-80">
          <h1 className="text-4xl lg:text-4xl font-semibold px-10 pt-10">
            {" "}
            Socials Medias
          </h1>

          <button
            className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700
      hover:border-blue-500 rounded  absolute top-10 right-0"
          >
            <a
              href={"/admin/social/add"}
              className="lg:text-1xl"
            >
              Add New Social Media
            </a>
          </button>
        </div>

        <div className="grid grid-cols-1 px-10 pt-10">
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{
              x: 0,
              opacity: 1,
              transition: {
                delay: 0.5,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 0.6 },
                ease: "easeIn",
              },
            }}
            className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg w-full"
          >
            <div className="p-4">
              <div className="divide-y divide-slate-200">
                <table className="table-auto w-full border-spacing-2 ">
                  <tbody>
                    {social &&
                      social.map((menuitem, i) => (
                        <tr key={i}>
                          <td className="w-auto border-separate border-b-[0.3px] border-slate-500 py-4 text-wrap">
                            <div>
                              <h6 className="text-slate-800 font-semibold">
                                {menuitem.name}
                              </h6>
                              <p className="text-slate-600 text-sm">
                                {menuitem.link}
                              </p>
                            </div>
                          </td>

                          <td className="order-last border-separate border-b-[0.3px] py-4  border-slate-500">
                            <a href={"/admin/social/" + menuitem.id}>
                              <button className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                                Edit
                              </button>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ListSocial;
